import React, { useState } from 'react';
import ImageSelector from './ImageSelector.js';
import EnhancedImageUpload from './EnhancedImageUpload.js';

const ImageManager = ({ value, onChange }) => {
  const [mode, setMode] = useState('select'); // 'select', 'upload', or 'link'
  const [linkInput, setLinkInput] = useState('');

  return (
    <div style={{ marginBottom: '15px' }}>
      <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
        Fish Image
      </label>
      
      {/* Mode Selector */}
      <div style={{ 
        display: 'flex', 
        gap: '10px', 
        marginBottom: '15px',
        padding: '8px',
        background: 'var(--muted)',
        borderRadius: '8px'
      }}>
        <button
          type="button"
          onClick={() => setMode('select')}
          className={mode === 'select' ? 'admin-button' : 'btn-ghost'}
          style={{
            fontSize: '14px',
            padding: '8px 16px',
            background: mode === 'select' ? 'var(--ocean-deep) !important' : 'transparent !important',
            color: mode === 'select' ? 'white !important' : 'var(--foreground) !important'
          }}
        >
          🖼️ Select from Collection
        </button>
        <button
          type="button"
          onClick={() => setMode('upload')}
          className={mode === 'upload' ? 'admin-button' : 'btn-ghost'}
          style={{
            fontSize: '14px',
            padding: '8px 16px',
            background: mode === 'upload' ? 'var(--ocean-deep) !important' : 'transparent !important',
            color: mode === 'upload' ? 'white !important' : 'var(--foreground) !important'
          }}
        >
          📤 Upload Custom Image
        </button>
        <button
          type="button"
          onClick={() => setMode('link')}
          className={mode === 'link' ? 'admin-button' : 'btn-ghost'}
          style={{
            fontSize: '14px',
            padding: '8px 16px',
            background: mode === 'link' ? 'var(--ocean-deep) !important' : 'transparent !important',
            color: mode === 'link' ? 'white !important' : 'var(--foreground) !important'
          }}
        >
          🔗 Use Image Link
        </button>
      </div>

      {/* Current Image Preview */}
      {value && (
        <div style={{ marginBottom: '15px' }}>
          <p style={{ 
            fontSize: '12px', 
            color: 'var(--muted-foreground)', 
            marginBottom: '8px' 
          }}>
            Current Image:
          </p>
          <div style={{ 
            position: 'relative', 
            display: 'inline-block',
            border: '2px solid var(--border)',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
            {value.startsWith('indexeddb://') ? (
              <div style={{
                width: '150px',
                height: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--muted)',
                fontSize: '12px',
                color: 'var(--muted-foreground)'
              }}>
                Custom Upload
              </div>
            ) : (
              <img 
                src={value} 
                alt="Current fish"
                style={{
                  width: '150px',
                  height: '100px',
                  objectFit: 'cover'
                }}
              />
            )}
            <button
              type="button"
              onClick={() => onChange('')}
              style={{
                position: 'absolute',
                top: '5px',
                right: '5px',
                background: 'var(--coral)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '22px',
                height: '22px',
                cursor: 'pointer',
                fontSize: '12px'
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* Mode Content */}
      {mode === 'select' ? (
        <div>
          <div style={{
            padding: '12px',
            background: 'hsl(142, 76%, 36%, 0.1)',
            borderRadius: '6px',
            marginBottom: '15px',
            border: '1px solid hsl(142, 76%, 36%, 0.3)'
          }}>
            <p style={{ margin: 0, fontSize: '13px', color: 'hsl(142, 76%, 25%)' }}>
              ✅ <strong>Recommended:</strong> Choose from our professional fish photo collection. 
              No storage limits, instant selection, perfect quality.
            </p>
          </div>
          <ImageSelector 
            value={value} 
            onChange={onChange} 
            hideLabel={true}
          />
        </div>
      ) : mode === 'upload' ? (
        <div>
          <div style={{
            padding: '12px',
            background: 'hsl(45, 93%, 47%, 0.1)',
            borderRadius: '6px',
            marginBottom: '15px',
            border: '1px solid hsl(45, 93%, 47%, 0.3)'
          }}>
            <p style={{ margin: 0, fontSize: '13px', color: 'hsl(45, 93%, 35%)' }}>
              ⚠️ <strong>Custom Upload:</strong> Uses advanced compression and IndexedDB storage. 
              Large files may take longer to load.
            </p>
          </div>
          <EnhancedImageUpload 
            value={value} 
            onChange={onChange} 
          />
        </div>
      ) : (
        <div>
          <div style={{
            padding: '12px',
            background: 'hsl(210, 100%, 50%, 0.1)',
            borderRadius: '6px',
            marginBottom: '15px',
            border: '1px solid hsl(210, 100%, 50%, 0.3)'
          }}>
            <p style={{ margin: 0, fontSize: '13px', color: 'hsl(210, 100%, 35%)' }}>
              🔗 <strong>Image Link:</strong> Paste a direct image URL from the web. 
              Fastest option, no storage used.
            </p>
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>
              Image URL
            </label>
            <input
              type="url"
              value={linkInput}
              onChange={(e) => setLinkInput(e.target.value)}
              placeholder="https://example.com/fish-image.jpg"
              style={{
                width: '100%',
                padding: '10px',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
          {linkInput && (
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>
                Preview
              </label>
              <div style={{ 
                border: '2px solid #ddd', 
                borderRadius: '6px', 
                overflow: 'hidden',
                display: 'inline-block'
              }}>
                <img 
                  src={linkInput} 
                  alt="Preview"
                  style={{
                    width: '200px',
                    height: '120px',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                  onLoad={(e) => {
                    e.target.style.display = 'block';
                    e.target.nextSibling.style.display = 'none';
                  }}
                />
                <div style={{
                  width: '200px',
                  height: '120px',
                  display: 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#f5f5f5',
                  color: '#666',
                  fontSize: '12px',
                  textAlign: 'center'
                }}>
                  ❌ Failed to load image<br/>
                  Check URL validity
                </div>
              </div>
            </div>
          )}
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              type="button"
              onClick={() => {
                if (linkInput.trim()) {
                  onChange(linkInput.trim());
                  setLinkInput('');
                }
              }}
              disabled={!linkInput.trim()}
              style={{
                padding: '10px 20px',
                background: linkInput.trim() ? 'var(--tropical-aqua)' : '#ccc',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: linkInput.trim() ? 'pointer' : 'not-allowed',
                fontWeight: 'bold'
              }}
            >
              Use This Image
            </button>
            <button
              type="button"
              onClick={() => setLinkInput('')}
              style={{
                padding: '10px 20px',
                background: 'transparent',
                color: '#666',
                border: '2px solid #ddd',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Clear
            </button>
          </div>
        </div>
      )}

      {/* Help Text */}
      <div style={{
        padding: '10px',
        background: 'var(--muted)',
        borderRadius: '6px',
        marginTop: '15px',
        fontSize: '12px',
        color: 'var(--muted-foreground)'
      }}>
        <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>💡 Recommendations:</p>
        <ul style={{ margin: 0, paddingLeft: '16px' }}>
          <li><strong>Collection:</strong> Best for standard fish types - instant, no storage limits</li>
          <li><strong>Image Link:</strong> Perfect for web images - fastest, no storage used</li>
          <li><strong>Upload:</strong> For specific/rare fish photos - compressed automatically</li>
          <li>Custom uploads are compressed to ~50-200KB for optimal performance</li>
        </ul>
      </div>
    </div>
  );
};

export default ImageManager;